import { BoxProps, chakra } from '@chakra-ui/react';
import React from 'react';

import { CmBox, CmLink } from '@/components/uiParts';

interface Props extends BoxProps {
  to: string;
  isDisabled?: boolean;
  isExternal?: boolean;
  isCurrentPage: boolean;
}

export const AccordionLinkButton: React.FC<Props> = ({
  children,
  to,
  isDisabled,
  isExternal,
  isCurrentPage,
  bgColor = 'primaryDarkBlue',
  ...rest
}): JSX.Element => {
  if (isCurrentPage) bgColor = 'hoveredDarkBlue';

  return (
    <CmLink to={to} h="100%" isDisabled={isDisabled} isExternal={isExternal}>
      <CmBox
        h="100%"
        display="flex"
        alignItems="center"
        _hover={{ bg: 'hoveredDarkBlue' }}
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        color={isDisabled ? 'gray.400' : 'inherit'}
        px={4}
        {...{ bgColor, ...rest }}
      >
        {children}
      </CmBox>
    </CmLink>
  );
};

export const AccordionLink = chakra(AccordionLinkButton, {
  baseStyle: {
    paddingTop: 2,
    paddingBottom: 2,
  },
});
